import {useEffect, useState} from "react";

export default function useHostNameXmlLinksIntegrationState(projectIntegration) {
    let [
        projectHostNameXmlLinksIntegrationState,
        setProjectHostNameXmlLinksIntegrationState,
    ] = useState({
        'hostNameAndXmlLinkList': [],
        'refundedOrderStatuses': projectIntegration?.refundedOrderStatuses ?? [],
        'unpaidOrderStatuses': projectIntegration?.unpaidOrderStatuses ?? [],
        'completedOrderStatuses': projectIntegration?.completedOrderStatuses ?? [],
    });

    return [
        projectHostNameXmlLinksIntegrationState,
        setProjectHostNameXmlLinksIntegrationState,
    ];
}
